module.exports = __webpack_public_path__ + "img/logo.7a300ed1.png";